import React from 'react';
import { motion } from 'framer-motion';
import { XCircle, Flame, BookOpen, Presentation, Activity, FileCheck, Folder, Layout } from 'lucide-react';
interface SystemFeaturesProps {
  onCTAClick?: () => void;
}
export function SystemFeatures({
  onCTAClick
}: SystemFeaturesProps) {
  const features = [{
    icon: BookOpen,
    text: 'clases organizadas'
  }, {
    icon: FileCheck,
    text: 'contenido desarrollado'
  }, {
    icon: Presentation,
    text: 'diapositivas listas'
  }, {
    icon: Activity,
    text: 'actividades dinámicas'
  }, {
    icon: FileCheck,
    text: 'evaluaciones completas'
  }, {
    icon: Folder,
    text: 'trabajos prácticos'
  }, {
    icon: Layout,
    text: 'estructura pedagógica'
  }, {
    icon: Presentation,
    text: 'recursos visuales profesionales'
  }];
  return <section className="py-16 md:py-24 bg-[#FAF7F2]" data-id="element-196">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-197">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-198">
          <h2 className="text-3xl md:text-5xl font-bold text-center mb-12 text-[#1F3A5F] font-oswald uppercase tracking-wide" data-id="element-199">
            💎 UN SISTEMA PENSADO PARA EL TRABAJO REAL DEL DOCENTE
          </h2>

          <div className="grid md:grid-cols-2 gap-8 mb-12" data-id="element-200">
            <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100 flex flex-col justify-center" data-id="element-201">
              <p className="text-xl mb-6 text-gray-600 font-medium" data-id="element-202">
                La mayoría de materiales:
              </p>
              <div className="flex items-center gap-4 bg-red-50/50 p-6 rounded-xl border border-red-100" data-id="element-203">
                <XCircle className="text-red-500 flex-shrink-0" size={32} data-id="element-204" />
                <span className="text-xl font-semibold text-gray-800" data-id="element-205">
                  solo traen teoría.
                </span>
              </div>
            </div>

            <div className="bg-[#1F3A5F] rounded-2xl p-8 shadow-lg text-white flex flex-col justify-center" data-id="element-206">
              <p className="text-xl mb-6 text-gray-300 font-medium" data-id="element-207">
                Pero este sistema:
              </p>
              <div className="flex items-center gap-4 bg-white/10 p-6 rounded-xl border border-white/20 backdrop-blur-sm" data-id="element-208">
                <Flame className="text-[#D4A574] flex-shrink-0" size={32} data-id="element-209" />
                <span className="text-xl font-bold text-white" data-id="element-210">
                  TIENE TODO LO QUE UN DOCENTE NECESITA
                </span>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-2xl p-8 md:p-12 shadow-sm border border-gray-100" data-id="element-211">
            <p className="text-2xl mb-8 font-semibold text-center text-[#1F3A5F]" data-id="element-212">
              Porque incluye:
            </p>

            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4 mb-10" data-id="element-213">
              {features.map((feature, index) => {
              const Icon = feature.icon;
              return <motion.div key={index} initial={{
                opacity: 0,
                scale: 0.9
              }} whileInView={{
                opacity: 1,
                scale: 1
              }} viewport={{
                once: true
              }} transition={{
                duration: 0.4,
                delay: index * 0.05
              }} className="flex flex-col items-center text-center bg-[#FAF7F2] p-6 rounded-xl border border-gray-100 hover:border-[#2D6A4F]/30 transition-colors pt-[3px] pb-[3px] pl-[24px] pr-[24px] gap-[5px]" data-id="element-214">
                    <div className="bg-white p-3 rounded-full shadow-sm" data-id="element-215">
                      <Icon className="text-[#2D6A4F]" size={24} data-id="element-216" />
                    </div>
                    <span className="text-sm md:text-base font-medium text-gray-800" data-id="element-217">
                      {feature.text}
                    </span>
                  </motion.div>;
            })}
            </div>

            <div className="text-center border-t border-gray-100 pt-8" data-id="element-218">
              <p className="text-xl text-gray-500 mb-2 font-playfair italic" data-id="element-219">
                Literalmente:
              </p>
              <p className="text-2xl md:text-3xl font-bold text-[#1F3A5F] mb-8" data-id="element-220">
                👉 abrís el archivo y podes dar la clase.
              </p>
              {onCTAClick && <button onClick={onCTAClick} className="bg-[#2D6A4F] hover:bg-[#1B4332] text-white text-lg md:text-xl font-bold py-4 px-8 md:px-12 rounded-xl shadow-lg transform hover:scale-105 transition-all inline-flex items-center justify-center gap-3" data-id="element-221">
                  ACCEDER AL SISTEMA COMPLETO 🚀
                </button>}
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}